"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const react_query_1 = require("@tanstack/react-query");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const _1 = require(".");
function default_1({ renderData }) {
    const { channel_id: userChannelId } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    const queryClient = (0, react_query_1.useQueryClient)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const onNotificationClick = (notification) => {
        const { id: notificationId, room_is_deleted, is_leader, is_click, channel_id: notificationChannelId, category_id, } = notification;
        if (!is_click)
            (0, _1.onNotificationLogClick)({ queryClient, notificationId });
        if (room_is_deleted && category_id !== 7) {
            (0, errors_1.alertConfirm)({ confirm, description: t('존재하지 않는 폼이에요') });
        }
        else if (!is_leader && !!is_click && userChannelId === notificationChannelId) {
            const { room_id, order_id } = notification;
            switch (category_id) {
                case 4: // ? BUYER_ROOM_NOTIFICATION
                    window.location.href = `/room/room_view/?room_id=${room_id}&detail=notice`;
                    break;
                case 5: // ? BUYER_LIKE_ROOM_UPCOMING_OPEN
                case 6: // ? BUYER_SUBSCRIBE_NEW_ROOM_OPEN
                    window.location.href = `/room/room_view/?room_id=${room_id}`;
                    break;
                case 7: // ? BUYER_WAYBILL_CODE
                    window.location.href = `/order/payment-detail-view/${order_id}`;
            }
        }
        else {
            window.location.href = `/notification/logs/${notificationId}/redirect`;
        }
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: renderData.map(notification => {
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ onClick: () => onNotificationClick(notification), className: notification.is_click ? 'surface-white' : 'surface-bg-light', css: {
                    display: 'flex',
                    columnGap: '10px',
                    padding: '20px 16px',
                    cursor: 'pointer',
                }, translate: "no" }, { children: [(0, jsx_runtime_1.jsx)(components_1.RoundImage, { size: 64, src: notification.room_thumbnail, altSrc: `${process.env.CDN_URL}/assets/images/thumbnail-${(0, functions_1.fixedRemainder)(notification.room_id, 12)}.webp`, altAfterImgWrapperCss: { borderRadius: '10px' } }), notification.is_leader ? ((0, jsx_runtime_1.jsx)(_1.LeaderNotificationContent, { notification: notification })) : ((0, jsx_runtime_1.jsx)(_1.BuyerNotificationContent, { notification: notification }))] }), `notification_log_${notification.id}`));
        }) }));
}
exports.default = default_1;
